
$(document).ready(function () {

    var patientVideoPlayer = new evoke.ui.VimeoPlayer({
        container: "#patientVideoPlayer",
        includeCloseButton: true,
        videos: [
            { name: "terry", callouts: ["facts", "copay"] },
            { name: "mitch", callouts: ["facts", "copay"] },
            { name: "carol", callouts: ["facts", "copay"] },
            { name: "commercial", callouts: ["facts", "copay"] },
            { name: "bill", callouts: ["facts", "copay"] },
            { name: "shayne", callouts: ["facts", "copay"] },
            { name: "rebecca", callouts: ["facts", "copay"] },
            { name: "rob", callouts: ["facts", "copay"] }
        ]
    });
    var $videoContainers = $(".video-container");
    var heroVideos = [];
    $videoContainers.each(function () {
        var $this = $(this);
        heroVideos.push({ name: $this.data("vidname"), time: $this.data("vidstart") });
    });
    var chosenHero = heroVideos[Math.floor(Math.random() * heroVideos.length)];

    $videoContainers.each(function (index, el) {
        var vidbox = $(this),
        vidname = vidbox.data('vidname');
        if (chosenHero.name == vidname) {
            vidbox.addClass('chosenhero');
        }
    });
    patientVideoPlayer.ready(function () {

        $(".video-play").click(function (e) {
            e.preventDefault();
            var vidbox = $(this).parents('.video-container');
            var vidname = vidbox.data('vidname');
            var vidstart = vidbox.data('vidstart') || "0";
            //console.log(vidname);
            vidbox.hide().addClass('activeHero').siblings().hide().removeClass('activeHero');
            $("#testimonial").addClass("blur");
            $("#patientVideoPlayer").show();
            patientVideoPlayer.play(vidname, vidstart);
        });
        patientVideoPlayer.find(".VideoPlayer_close").on('click', function (e) {
            e.preventDefault();
            $("#patientVideoPlayer").hide();
            $(".activeHero").show();
            patientVideoPlayer.pause();
        });
    });

    
});
